export default __webpack_public_path__ + "static/logo-alt-63bf4ca4803ccfee586dc81068e8baf6.png";